import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import EmailIcon from "@mui/icons-material/Email";
import { IntegrationType } from "./integrationApi";
//@ts-ignore
import dropbox from "assets/dropbox.svg";
//@ts-ignore
import { ReactComponent as FtpIcon } from "assets/ftp.svg";
//@ts-ignore
import googledrive from "assets/googledrive.svg";
//@ts-ignore
import mailchimpb from "assets/mailchimp-black.svg";
//@ts-ignore
import mailchimpw from "assets/mailchimp-white.svg";
//@ts-ignore
import { SvgIcon, useTheme } from "@mui/material";
//@ts-ignore
import onedrive from "assets/onedrive.svg";

export interface IntegrationIconProps {
  type: IntegrationType;
  size?: "medium" | "large" | "small";
}
export default function IntegrationIcon({
  type,
  size = "medium",
}: IntegrationIconProps) {
  const theme = useTheme();
  let w = 20;
  if (size === "small") {
    w = 16;
  }
  if (size === "large") {
    w = 30;
  }
  if (type === IntegrationType.GoogleDrive) {
    return <img src={googledrive} width={w} height={w} />;
  }
  if (type === IntegrationType.OneDrive) {
    return <img src={onedrive} width={w} height={w} />;
  }
  if (type === IntegrationType.Dropbox) {
    return <img src={dropbox} width={w} height={w} />;
  }
  if (type === IntegrationType.Ftp) {
    return (
      <SvgIcon color="primary" fontSize={size}>
        <FtpIcon />
      </SvgIcon>
    );
  }
  if (type === IntegrationType.MailChimp) {
    if (theme.palette.mode === "dark") {
      return <img src={mailchimpw} width={w} height={w} />;
    } else {
      return <img src={mailchimpb} width={w} height={w} />;
    }
  }
  if (type === IntegrationType.Email) {
    return <EmailIcon fontSize={size} color="primary" />;
  }
  if (type === IntegrationType.Smtp) {
    return <AlternateEmailIcon fontSize={size} color="primary" />;
  }
  return null;
}
